export default __webpack_public_path__ + "error.b96741b5.png";